import React from 'react';
import { CancelButton as CancelButtonBase } from '../button/CancelButton';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { useFormContext } from 'react-hook-form-legacy';

type Props = {
  className?: string;
  size?: 'sm' | 'lg';
  onClick?: () => void;
};

const CancelButton: React.FC<React.PropsWithChildren<Props>> = ({
  size,
  className,
  children,
  onClick,
}) => {
  const {
    reset,
    formState: { isSubmitting },
  } = useFormContext();
  return (
    <CancelButtonBase
      disabled={isSubmitting}
      size={size}
      label={undefined}
      className={['lift', className].join(' ')}
      onClick={(e) => {
        e.preventDefault();
        onClick ? onClick() : reset();
      }}>
      {children}
    </CancelButtonBase>
  );
};

export default CancelButton;
